import React from "react";
import { Navigate } from "react-router-dom";
import Spinner from "../Spinner";

const RequiredAuth = ({ children, isLoading, user }) => {
  return isLoading ? (
    <Spinner className="flex justify-center items-center h-screen w-full" />
  ) : !user ? (
    <Navigate to="/auth/login" replace />
  ) : (
    <>{children}</>
  );
};

export default RequiredAuth;
